const COMMON = {

}

const DARK = {
    ...COMMON,
    PRIMARY: '#00B3AC',
    EKYC__COLOR: '#00B3AC',
}

const LIGHT = {
    ...COMMON,
    PRIMARY: '#BC579D',
    EKYC__COLOR: '#BC579D',
}

const CN_DARK = {
    ...DARK,
    //--Các value thay đổi cho china
}

const CN_LIGHT = {
    ...LIGHT,
    //--Các value thay đổi cho china
}

export default {
    DARK,
    LIGHT,
    CN_DARK,
    CN_LIGHT,
}
